<div class="col-md-6 offset-md-3 mt-5">
  <!-- <div class="alert alert-info">
  Username: test<br />
  Password: test
</div> -->
<div class="ng-container registration-logo">
  <img src="assets/login-logo.png">
</div>
<div class="card">
  <h4 class="card-header">Entrarit - Registration</h4>
  <div class="card-body">
    <form [formGroup]="registrationForm" (ngSubmit)="onSubmit()">
      <div class="form-group">
        <label class="sr-only" for="fullname">Full Name</label>
        <div class="input-group mb-2">
          <div class="input-group-prepend">
            <div class="input-group-text"><fa-icon [icon]="faUser"></fa-icon></div>
          </div>
          <input type="text" formControlName="fullname" class="form-control py-0" name="fullname" id="fullname" [pattern]="fullNamePattern" placeholder="First and Last name" [ngClass]="{ 'is-invalid': submitted && f.fullname.errors, 'is-valid': f.fullname.valid && f.fullname.touched }" >
          @if (f.fullname && f.fullname.errors) {
            <div class="invalid-feedback">
              @if (f.fullname.errors.required) {
                <div>Full name must be entered e.g John Brown</div>
              }
            </div>
          }
          @if (f.fullname && f.fullname.errors?.pattern ) {
            <div class="invalid-feedback">
              Full name must be entered in the format First Last e.g John Brown
            </div>
          }
        </div>
      </div>


      <div class="form-group">
        <label class="sr-only" for="username">Username</label>
        <div class="input-group mb-2">
          <div class="input-group-prepend">
            <div class="input-group-text"><fa-icon [icon]="faUser"></fa-icon></div>
          </div>
          <input type="text" formControlName="username" class="form-control py-0" name="username" id="username" [pattern]="usernamePattern" placeholder="Username" [ngClass]="{ 'is-invalid': submitted && f.username.errors, 'is-valid': f.username.valid && f.username.touched }" >
          @if (submitted && f.username.errors) {
            <div class="invalid-feedback">
              @if (f.username.errors.required) {
                <div>Username is required</div>
              }
            </div>
          }
          @if (f.username && f.username.errors?.pattern) {
            <div class="invalid-feedback">
              Username must be 3 or more characters, No spaces. Limit: 30 characters.
            </div>
          }
        </div>
      </div>

      <div class="form-group">
        <label class="sr-only" for="address">Address 1</label>
        <div class="input-group mb-2">
          <div class="input-group-prepend">
            <div class="input-group-text"><fa-icon [icon]="faMapMarkedAlt"></fa-icon></div>
          </div>
          <input type="text" formControlName="address" class="form-control py-0" name="address" id="address" [pattern]="addressPattern" placeholder="Address 1" [ngClass]="{ 'is-invalid': submitted && f.address.errors, 'is-valid': f.address.valid && f.address.touched }" >
          @if (submitted && f.address.errors) {
            <div class="invalid-feedback">
              @if (f.address.errors.required) {
                <div>Address is required</div>
              }
            </div>
          }
          @if (f.address && f.address.errors?.pattern) {
            <div class="invalid-feedback">
              Invalid address. Sample address, e.g 1 Sleep Close, Kingston
            </div>
          }
        </div>
      </div>
      <div class="form-group">
        <label class="sr-only" for="address">Apartment/Lot Number</label>
        <div class="input-group mb-2">
          <div class="input-group-prepend">
            <div class="input-group-text"><fa-icon [icon]="faMapMarkedAlt"></fa-icon></div>
          </div>
          <input type="text" formControlName="apartmentnumber" class="form-control py-0" name="apartmentnumber" id="apartmentnumber" [pattern]="lotPattern" placeholder="Apartment/Lot Number e.g 20" [ngClass]="{ 'is-invalid': submitted && f.apartmentnumber.errors, 'is-valid': f.apartmentnumber.valid && f.apartmentnumber.touched }" >
          @if (submitted && f.apartmentnumber.errors) {
            <div class="invalid-feedback">
              @if (f.apartmentnumber.errors.required) {
                <div>Apartment number or Lot number is required</div>
              }
            </div>
          }
          @if (f.apartmentnumber && f.apartmentnumber.errors?.pattern) {
            <div class="invalid-feedback">
              Invalid Lot Number. Valid lot numbers e.g 1 or 30B
            </div>
          }
        </div>
      </div>

      <!-- <div class="form-group">
      <label class="sr-only" for="blockname">Block Name</label>
      <div class="input-group mb-2">
        <div class="input-group-prepend">
          <div class="input-group-text"><fa-icon [icon]="faMapMarkedAlt"></fa-icon></div>
        </div>
        <select class="form-control" id="blockname" formControlName="blockname">
          <option selected>Choose block...</option>
          <option value="A">A</option>
          <option value="B">B</option>
          <option value="C">C</option>
          <option value="D">D</option>
          <option value="E">E</option>
          <option value="F">F</option>
          <option value="G">G</option>
          <option value="H">H</option>
          <option value="J">J</option>
        </select>
        <div *ngIf="submitted && f.blockname.errors" class="invalid-feedback">
          <div *ngIf="f.blockname.errors.required">Please select block name</div>
        </div>
        <div *ngIf="f.blockname && f.blockname.errors?.pattern" class="invalid-feedback">
          Invalid Block selected. Valid lot numbers e.g A - J, except I
        </div>
      </div>
    </div> -->




    <!--
    <div class="form-group ">
      <div class="col-md-6 d-inline-block">
        <label for="blockname">Block</label>
        <select class="form-control" id="blockname" formControlName="blockname">
          <option></option>
          <option value="A">A</option>
          <option value="B">B</option>
          <option value="C">C</option>
          <option value="D">D</option>
          <option value="E">E</option>
          <option value="F">F</option>
          <option value="G">G</option>
          <option value="H">H</option>
          <option value="J">J</option>
        </select>
      </div>
    </div>  -->

    <div class="form-group">
      <!-- Default input -->
      <label class="sr-only" for="phone">Phone</label>
      <div class="input-group mb-2">
        <div class="input-group-prepend">
          <div class="input-group-text"><fa-icon [icon]="faPhoneAlt"></fa-icon></div>
        </div>
        <input type="text" formControlName="phone" class="form-control py-0" id="inlineFormInputGroup" placeholder="Phone" pattern="^\d{10}$" [ngClass]="{ 'is-invalid': submitted && f.phone.errors, 'is-valid': f.phone.valid && f.phone.touched }">
        @if (submitted && f.phone.errors) {
          <div class="invalid-feedback">
            @if (f.phone.errors.required) {
              <div>Phone number is required</div>
            }
          </div>
        }
        @if (f.phone && f.phone.errors?.pattern) {
          <div class="invalid-feedback">
            10 digit Phone number, without space or dash
          </div>
        }
      </div>
    </div>


    <div class="form-group">
      <label class="sr-only" for="email">Email</label>
      <div class="input-group mb-2">
        <div class="input-group-prepend">
          <div class="input-group-text"><fa-icon [icon]="faEnvelope"></fa-icon></div>
        </div>
        <input type="email" formControlName="email" class="form-control py-0" name="email" id="email"  placeholder="Email" [pattern]="emailPattern"  [ngClass]="{ 'is-invalid': submitted && f.email.errors, 'is-valid': f.email.valid && f.email.touched }" >
        @if (submitted && f.email.errors) {
          <div class="invalid-feedback">
            @if (f.email.errors.required) {
              <div>Email is required</div>
            }
          </div>
        }
        @if (f.email && f.email.errors?.pattern) {
          <div class="invalid-feedback">
            Email address is not valid
          </div>
        }
      </div>
    </div>

    <div class="form-group">
      <label class="sr-only" for="password">Password</label>
      <div class="input-group mb-2">
        <div class="input-group-prepend">
          <div class="input-group-text"><fa-icon [icon]="faKey"></fa-icon></div>
        </div>
        <input type="password" formControlName="password" class="form-control py-0" (change)="onPasswordChange()" name="password" id="password"  placeholder="Password" [pattern]="passwordPattern"  [ngClass]="{ 'is-invalid': submitted && f.password.errors, 'is-valid': f.password.valid && f.password.touched }" >
        @if (submitted && f.password.errors) {
          <div class="invalid-feedback">
            @if (f.password.errors.required) {
              <div>Password is required</div>
            }
          </div>
        }
        @if (f.password && f.password.errors?.pattern) {
          <div class="invalid-feedback">
            Password has to be 5 or more characters.
          </div>
        }
      </div>
    </div>

    <div class="form-group">
      <label class="sr-only" for="confirmPassword">Password</label>
      <div class="input-group mb-2">
        <div class="input-group-prepend">
          <div class="input-group-text"><fa-icon [icon]="faKey"></fa-icon></div>
        </div>
        <input type="password" formControlName="confirmPassword" class="form-control py-0" (change)="onPasswordChange()" name="confirmPassword" id="confirmPassword"  placeholder="Confirm Password" [pattern]="passwordPattern"  [ngClass]="{ 'is-invalid': submitted && f.confirmPassword.errors, 'is-valid': f.confirmPassword.valid && f.confirmPassword.touched }" >
        @if (submitted && f.confirmPassword.errors) {
          <div class="invalid-feedback">
            @if (f.confirmPassword.errors.required) {
              <div>Please confirm password</div>
            }
          </div>
        }
        @if (f.confirmPassword && f.confirmPassword.errors?.pattern) {
          <div class="invalid-feedback">
            Confirm Password has to be 5 or more characters. Less than 30 characters.
          </div>
        }
        @if (f.password && f.confirmPassword && f.confirmPassword.hasError('mismatch')) {
          <div class="invalid-feedback">
            Passwords do not match
          </div>
        }
      </div>
    </div>

    <!-- <button type="button" (click)="goBack()" class="btn btn-primary">
    Back  <fa-icon class="l-icon" [icon]="faArrowLeft"></fa-icon>
  </button> -->

  <button [disabled]="loading" class="btn btn-success float-right">
    @if (loading) {
      <span class="spinner-border spinner-border-sm mr-1"></span>
    }
    Submit <fa-icon class="l-icon" [icon]="faPaperPlane"></fa-icon>
  </button>

  @if (error) {
    <div class="alert alert-danger mt-3 mb-0">{{error}}</div>
  }
</form>
</div>
</div>
</div>